import * as React from 'react';

import gql from 'graphql-tag';
import { Query } from 'react-apollo';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';

import DeleteIcon from '@material-ui/icons/Delete';
import LinearProgress from '@material-ui/core/LinearProgress';

import "./TablePublishers.scss";

// tslint:disable-next-line:no-empty-interface
export interface ITablePublishersPros {
    receivePublisherToEdit(publisher: any): void
    receivePublisherToDelete(publisher: any): void
}

export interface ITablePublishers {
    count: number,
    limit: number,
    offset: number,
    openDialogMoreInfo: boolean,
    page: number,
    publisher: {
        cnpj: string,
        id: number,
        id_father: number,
        publisher: string,
        publisher_father: string
    },
    rowToView: any,
    rows?: any
}

const QUERY_SEARCH_PUBLISHER = gql`
    query getPublisherRegister($customFilter: PublisherFilter) { 
        getPublisherRegister(publisherFilter: $customFilter) { 
            cnpj, 
            id,
            publisher, 
            id_father,
            publisher_father
        } 
    } 
`;

export class TablePublishers
  extends React.Component<ITablePublishersPros, ITablePublishers> {

    constructor(props: ITablePublishersPros) {
        super(props);
    
        this.state = {
            count: 10,
            limit: 10,
            offset: 0,
            openDialogMoreInfo: false,
            page: 0,
            publisher: {
                cnpj: '',
                id: 0,
                id_father: 0,
                publisher: '',
                publisher_father: ''
            },
            rowToView: {},
            rows: []
        }

        this.handleChangePage = this.handleChangePage.bind(this);
    }

    public changeState = (publisher:any) => {
        this.setState( {publisher} );
    }

    public render() {

        const filter = {
            "customFilter" : {
                cnpj: this.state.publisher.cnpj,
                id: this.state.publisher.id,
                id_father: this.state.publisher.id_father,
                publisher: this.state.publisher.publisher,
                publisher_father: this.state.publisher.publisher_father,
            }
        };

        return (
            <Query query={QUERY_SEARCH_PUBLISHER} variables={filter} partialRefetch={true} fetchPolicy="no-cache" >
                {({ loading, error, data}) => {
                    return (
                        <div>
                            {loading ? <LinearProgress /> : 
                                <div>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell  >Ordem</TableCell>
                                                <TableCell  >Selo</TableCell>
                                                <TableCell  >CNPJ</TableCell>
                                                <TableCell  >Editora</TableCell>
                                            </TableRow>
                                        </TableHead>
                        
                                        {this.getTableBody(error, data)}
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        page={this.state.page}
                                        count={data && data.getPublisherRegister ? data.getPublisherRegister.length : this.state.count}
                                        rowsPerPage={this.state.limit}
                                        rowsPerPageOptions={[]}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={undefined}
                                    />
                                </div>
                            }
                            
                        </div>
                    );
                }}
            </Query>
            
        );
    }

    public getTableBody (error: any, data:any) {
         
        if(!error && data && data.getPublisherRegister) {

            return (
                <TableBody>
                    {
                        this.paginacaoVirtual(data.getPublisherRegister).map((row: any, key: number) => {
                        return (
                            <TableRow key={key}>
                                <TableCell >{ 1 + key + (this.state.page * this.state.limit) }</TableCell>
                                <TableCell  component="th" scope="row">{row.publisher}</TableCell>
                                <TableCell  >{row.cnpj}</TableCell>
                                <TableCell  >{row.publisher_father}</TableCell>
                                <TableCell  className="actionColumn">
                                    <IconButton className="editAction"  onClick={this.editItem.bind(this, row)} aria-label="Editar">
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton className="viewAction" color="primary" onClick={this.deleteItem.bind(this, row)} aria-label="Editar">
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        );
                        })
                    }
                </TableBody>
            );
        } else {
            return null;
        }
    }

    public editItem (row : any) {
        this.props.receivePublisherToEdit(row);
    };

    public deleteItem (row: any) {
        this.props.receivePublisherToDelete(row);
    }

    /**
     * Pagination
     * 
     * Methods add pagination to the result table
     * 
     */
    private paginacaoVirtual = (bookstoreAnalysisData: any[]) => {
        const start = this.state.offset;
        const end = start + 10;
        return bookstoreAnalysisData.slice(start, end)
    }

    private handleChangePage(ev: any, pageParam: number) {

        if (pageParam <= this.state.page) {
            this.setState({
                offset: pageParam * 10 <= 0 ? 0 : pageParam * 10,
                page: pageParam,
            });
        } else {
            this.setState({
                offset: pageParam * 10,
                page: pageParam,
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/component/administration/registers/publishers/TablePublishers.tsx